<template>
	<ul
		ref="horizontal"
		:class="[
			'horizontal',
			{
				active: isDown
			}
		]"
		@mousedown="mousedown"
		@mouseup="mouseup"
		@mouseleave="mouseleave"
		@mousemove="mousemove"
	>
		<slot name="scroll-items"> </slot>
	</ul>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const isDown = ref(false);
let startX = 0;
let scrollLeft = 0;
const scrollSpeed = 1;

const horizontal = ref<HTMLElement | null>(null);

function mousedown(e: MouseEvent): void {
	isDown.value = true;
	if (horizontal.value) {
		startX = e.pageX - horizontal.value.offsetLeft;
		scrollLeft = horizontal.value.scrollLeft;
	}
}

function mouseleave(): void {
	isDown.value = false;
}

function mouseup(): void {
	isDown.value = false;
}

function mousemove(e: MouseEvent): void {
	if (!isDown.value) return;
	e.preventDefault();
	if (horizontal.value) {
		const x = e.pageX - horizontal.value.offsetLeft;
		const walk = (x - startX) * scrollSpeed;
		horizontal.value.scrollLeft = scrollLeft - walk;
	}
}
</script>

<style scoped lang="scss">
.horizontal {
	display: flex;
	gap: 1.5rem;
	overflow-x: scroll;
	white-space: nowrap;
	scrollbar-width: none;
	-ms-overflow-style: none;
	flex-wrap: nowrap;
	cursor: pointer;
	user-select: none;
	transition: all 0.2s;

	&.active {
		cursor: grabbing;
		cursor: -webkit-grabbing;
		transform: scale(1.01);
	}

	&::-webkit-scrollbar {
		display: none;
	}
}
</style>
